export default "__VITE_ASSET__BUikzdxj__"